export function leiFormatValidator() {
  return (control) => {
    const lei = control.value;
    if (!lei) {
      return null;
    }
    const regex = /^[A-Z0-9]{18}[0-9]{2}$/;
    if (!regex.test(lei)) {
      return {
        incorrect: true,
        message:
          'LEI must be exactly 20 characters long, using only uppercase letters (A–Z) and digits (0–9), with the last two characters being digits.',
      };
    }

    return null;
  };
}
